// extracted by mini-css-extract-plugin
export var card = "_53-0";
export var content = "_53-1";
export var contentLoading = "_53-2";